import React from 'react';
import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';

import CompositeChartPopupOption from './CompositeChartPopupOption';
import ExplainValueOption from './ExplainValueOption';
import Option from './Option';

const List = styled.div`
  background-color: var(--color-bg-primary);
  border-radius: 3px;
  border: 1px var(--color-logan) solid;
  width: 90%;
`;

const DashboardContextMenu = ({
  metrics,
  label,
  setSelectedMetric,
}: {
  metrics: (Metrics.NormalMetric | Metrics.SpecialMetric)[];
  label: string;
  setSelectedMetric: React.Dispatch<
    React.SetStateAction<
      Metrics.NormalMetric | Metrics.SpecialMetric | undefined
    >
  >;
}) => (
  <List>
    <ExplainValueOption label={label} />
    <CompositeChartPopupOption label={label} />
    {metrics.map((m) => (
      <Option
        onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          setSelectedMetric(m);
          e.preventDefault();
          e.stopPropagation();
        }}
        key={m.id}
      >
        <Typography.Body type={'Label'}>
          {label !== '' ? `View ${m.name} for ${label}` : `View ${m.name}`}
        </Typography.Body>
      </Option>
    ))}
  </List>
);

export default DashboardContextMenu;
